import oDataQuery from 'odata-query'
import { get } from '@user/store/services/crud'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '@user/features/Activity/ActivitySummary/constants'
import { getFilterArray, getOverDueFilter } from './utils'

export const fetchOverdueActivitiesCount = createAsyncThunk<
  number,
  string,
  { rejectValue: string }
>('activities/fetchOverdueCount', async (userId, thunkApi) => {
  const query = oDataQuery({
    count: true,
    top: 0,
    filter: [...getFilterArray(userId), getOverDueFilter()],
  })

  const response = await get(`${baseUrl}${query}`)

  if (response.ok) {
    const result = await response.json()
    return result['@odata.count']
  }
  return thunkApi.rejectWithValue(await response.json())
})
